import { Button, Popconfirm, Space, Table, Tooltip } from "antd";
import { DeleteFilled, CheckCircleTwoTone, CloseCircleTwoTone, RollbackOutlined, UsergroupAddOutlined } from "@ant-design/icons";

const expandedRowRender = (record) => {
	return (
		<>
			<Table
				bordered={true}
				columns={[{ title: "Nombre", dataIndex: "namesub", key: "namesub" }]}
				dataSource={record.subCategories}
				className="cmsSubTable"
				pagination={false}
			/>
		</>
	);
};

const propsColumnsCategories = (limitPagination) => {
	return {
		size: "large",
		bordered: true,
		pagination: {
			position: ["none", "none"],
			pageSize: limitPagination,
		},
		expandable: {
			expandedRowRender,
		},
		className: "cmsTable",
	};
};

const columnsType = (editAction, deleteAction, addSubCategory) => {
	return [
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			width: 240,
			render: (text) => <span>{text}</span>,
			sorter: (a, b) => {
				if (a.name < b.name) {
					return -1;
				}
				if (a.name > b.name) {
					return 1;
				}
				return 0;
			},
		},
		{
			title: "Esta activo",
			dataIndex: "isActive",
			key: "isActive",
			width: 120,
			render: (_, record) => {
				const status = record.isActive;
				return (
					<>
						<span className="flex justify-center items-center text-2xl">
							{status ? <CheckCircleTwoTone twoToneColor="green" /> : <CloseCircleTwoTone twoToneColor="red" />}
						</span>
					</>
				);
			},
			sorter: (a, b) => a.isActive - b.isActive,
		},
		{
			title: "Action",
			key: "action",
			width: 120,
			render: (_, record) => {
				const status = record.isActive;
				return (
					<Space size="middle">
						{status && (
							<>
								{/* <Tooltip title="Editar categoria">
									<Button
										type="text"
										icon={<EditFilled />}
										onClick={() => {
											editAction(record);
										}}
									/>
								</Tooltip> */}
								<Tooltip title="Agrega sub categorias">
									<Button
										type="text"
										icon={<UsergroupAddOutlined />}
										onClick={() => {
											addSubCategory(record);
										}}
									/>
								</Tooltip>
							</>
						)}
						<Popconfirm title={`${status ? "¿Seguro eliminar?" : "¿Volver activar?"}`} onConfirm={() => deleteAction(record.key)}>
							<Tooltip title="Desactivar categoria">
								<Button type="text" icon={status ? <DeleteFilled /> : <RollbackOutlined />} />
							</Tooltip>
						</Popconfirm>
					</Space>
				);
			},
		},
	];
};

export const columnsCategory = (editAction, deleteAction, limitPagination, addSubCategory) => {
	const columns = columnsType(editAction, deleteAction, addSubCategory);
	const props = propsColumnsCategories(limitPagination);
	return {
		columns,
		props,
	};
};
